module.exports = __webpack_public_path__ + "img/tb_game.40174f48.jpg";